/**
 * VCDR Backend Public APIs
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
/* tslint:disable:no-unused-variable member-ordering */

import { Inject, Injectable, Optional }                      from '@angular/core';
import { HttpClient, HttpHeaders, HttpParams,
         HttpResponse, HttpEvent, HttpParameterCodec, HttpContext 
        }       from '@angular/common/http';
import { CustomHttpParameterCodec }                          from '../encoder';
import { Observable }                                        from 'rxjs';

// @ts-ignore
import { RolloutAddableTargetPaginatedResponse } from '../model/rolloutAddableTargetPaginatedResponse';
// @ts-ignore
import { RolloutNotificationConfigPatchRequest } from '../model/rolloutNotificationConfigPatchRequest';
// @ts-ignore
import { RolloutNotificationConfigRequest } from '../model/rolloutNotificationConfigRequest';
// @ts-ignore
import { RolloutNotificationConfigResponse } from '../model/rolloutNotificationConfigResponse';
// @ts-ignore
import { RolloutPlanCreateRequest } from '../model/rolloutPlanCreateRequest';
// @ts-ignore
import { RolloutPlanOptionsSpecResponse } from '../model/rolloutPlanOptionsSpecResponse';
// @ts-ignore
import { RolloutPlanPaginatedResponse } from '../model/rolloutPlanPaginatedResponse';
// @ts-ignore
import { RolloutPlanResponse } from '../model/rolloutPlanResponse';
// @ts-ignore
import { RolloutPlanSummary } from '../model/rolloutPlanSummary';
// @ts-ignore
import { RolloutPlanUpdateRequest } from '../model/rolloutPlanUpdateRequest';
// @ts-ignore
import { RolloutState } from '../model/rolloutState';
// @ts-ignore
import { RolloutTargetAddRequest } from '../model/rolloutTargetAddRequest';
// @ts-ignore
import { RolloutTargetDetailedPaginatedResponse } from '../model/rolloutTargetDetailedPaginatedResponse';
// @ts-ignore
import { RolloutTargetPaginatedResponse } from '../model/rolloutTargetPaginatedResponse';
// @ts-ignore
import { RolloutTargetPatchRequest } from '../model/rolloutTargetPatchRequest';
// @ts-ignore
import { RolloutTargetRemoveRequest } from '../model/rolloutTargetRemoveRequest';
// @ts-ignore
import { RolloutTargetResponse } from '../model/rolloutTargetResponse';
// @ts-ignore
import { RolloutTargetState } from '../model/rolloutTargetState';
// @ts-ignore
import { RolloutTargetStatus } from '../model/rolloutTargetStatus';
// @ts-ignore
import { RolloutTargetType } from '../model/rolloutTargetType';
// @ts-ignore
import { RolloutType } from '../model/rolloutType';
// @ts-ignore
import { RolloutWaveCreateRequest } from '../model/rolloutWaveCreateRequest';
// @ts-ignore
import { RolloutWavePaginatedResponse } from '../model/rolloutWavePaginatedResponse';
// @ts-ignore
import { RolloutWaveResponse } from '../model/rolloutWaveResponse';
// @ts-ignore
import { RolloutWaveState } from '../model/rolloutWaveState';
// @ts-ignore
import { RolloutWaveSummary } from '../model/rolloutWaveSummary';
// @ts-ignore
import { RolloutWaveUpdateRequest } from '../model/rolloutWaveUpdateRequest';

// @ts-ignore
import { BASE_PATH, COLLECTION_FORMATS }                     from '../variables';
import { Configuration }                                     from '../configuration';
import { BaseService } from '../api.base.service';



@Injectable({
  providedIn: 'root'
})
export class FleetOrchestrationOperatorService extends BaseService {

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string|string[], @Optional() configuration?: Configuration) {
        super(basePath, configuration);
    }

    /**
     * Add targets as part of a wave.
     * Add targets as part of a wave.
     * @param rolloutPlanId Rollout Plan ID
     * @param rolloutWaveId Rollout Wave ID
     * @param rolloutTargetAddRequest Rollout Target Add Payload
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public addTargetsIntoWave(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetAddRequest: RolloutTargetAddRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<RolloutTargetStatus>>;
    public addTargetsIntoWave(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetAddRequest: RolloutTargetAddRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<RolloutTargetStatus>>>;
    public addTargetsIntoWave(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetAddRequest: RolloutTargetAddRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<RolloutTargetStatus>>>;
    public addTargetsIntoWave(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetAddRequest: RolloutTargetAddRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling addTargetsIntoWave.');
        }
        if (rolloutWaveId === null || rolloutWaveId === undefined) {
            throw new Error('Required parameter rolloutWaveId was null or undefined when calling addTargetsIntoWave.');
        }
        if (rolloutTargetAddRequest === null || rolloutTargetAddRequest === undefined) {
            throw new Error('Required parameter rolloutTargetAddRequest was null or undefined when calling addTargetsIntoWave.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/waves/${this.configuration.encodeParam({name: "rolloutWaveId", value: rolloutWaveId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/targets`;
        return this.httpClient.request<Array<RolloutTargetStatus>>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rolloutTargetAddRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a rollout notification config
     * Create a rollout notification config
     * @param rolloutNotificationConfigRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createNotificationConfig(rolloutNotificationConfigRequest?: RolloutNotificationConfigRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RolloutNotificationConfigResponse>;
    public createNotificationConfig(rolloutNotificationConfigRequest?: RolloutNotificationConfigRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutNotificationConfigResponse>>;
    public createNotificationConfig(rolloutNotificationConfigRequest?: RolloutNotificationConfigRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutNotificationConfigResponse>>;
    public createNotificationConfig(rolloutNotificationConfigRequest?: RolloutNotificationConfigRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/notifications`;
        return this.httpClient.request<RolloutNotificationConfigResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rolloutNotificationConfigRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a rollout.
     * Create a rollout.
     * @param rolloutPlanCreateRequest Specification to create rollout
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createRolloutOperator(rolloutPlanCreateRequest: RolloutPlanCreateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<RolloutPlanResponse>;
    public createRolloutOperator(rolloutPlanCreateRequest: RolloutPlanCreateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutPlanResponse>>;
    public createRolloutOperator(rolloutPlanCreateRequest: RolloutPlanCreateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutPlanResponse>>;
    public createRolloutOperator(rolloutPlanCreateRequest: RolloutPlanCreateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanCreateRequest === null || rolloutPlanCreateRequest === undefined) {
            throw new Error('Required parameter rolloutPlanCreateRequest was null or undefined when calling createRolloutOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts`;
        return this.httpClient.request<RolloutPlanResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rolloutPlanCreateRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Create a rollout wave.
     * Create a rollout wave.
     * @param rolloutPlanId Rollout Plan ID
     * @param rolloutWaveCreateRequest Specification to create rollout wave
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public createRolloutWavesOperator(rolloutPlanId: string, rolloutWaveCreateRequest: RolloutWaveCreateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<RolloutWaveResponse>;
    public createRolloutWavesOperator(rolloutPlanId: string, rolloutWaveCreateRequest: RolloutWaveCreateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutWaveResponse>>;
    public createRolloutWavesOperator(rolloutPlanId: string, rolloutWaveCreateRequest: RolloutWaveCreateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutWaveResponse>>;
    public createRolloutWavesOperator(rolloutPlanId: string, rolloutWaveCreateRequest: RolloutWaveCreateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling createRolloutWavesOperator.');
        }
        if (rolloutWaveCreateRequest === null || rolloutWaveCreateRequest === undefined) {
            throw new Error('Required parameter rolloutWaveCreateRequest was null or undefined when calling createRolloutWavesOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/waves`;
        return this.httpClient.request<RolloutWaveResponse>('post', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rolloutWaveCreateRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a rollout notification config
     * Delete a rollout notification config
     * @param rolloutNotificationName Rollout notification name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRolloutNotificationConfig(rolloutNotificationName: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteRolloutNotificationConfig(rolloutNotificationName: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteRolloutNotificationConfig(rolloutNotificationName: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteRolloutNotificationConfig(rolloutNotificationName: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutNotificationName === null || rolloutNotificationName === undefined) {
            throw new Error('Required parameter rolloutNotificationName was null or undefined when calling deleteRolloutNotificationConfig.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/notifications/${this.configuration.encodeParam({name: "rolloutNotificationName", value: rolloutNotificationName, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a rollout.
     * Delete a rollout.
     * @param rolloutPlanId Rollout Plan ID
     * @param force Invoke API, overriding any validations
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRolloutOperator(rolloutPlanId: string, force?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteRolloutOperator(rolloutPlanId: string, force?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteRolloutOperator(rolloutPlanId: string, force?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteRolloutOperator(rolloutPlanId: string, force?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling deleteRolloutOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>force, 'force');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Delete a rollout wave.
     * Delete a rollout wave.
     * @param rolloutPlanId Rollout Plan ID
     * @param rolloutWaveId Rollout Wave ID
     * @param force Invoke API, overriding any validations
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public deleteRolloutWaveOperator(rolloutPlanId: string, rolloutWaveId: string, force?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any>;
    public deleteRolloutWaveOperator(rolloutPlanId: string, rolloutWaveId: string, force?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<any>>;
    public deleteRolloutWaveOperator(rolloutPlanId: string, rolloutWaveId: string, force?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<any>>;
    public deleteRolloutWaveOperator(rolloutPlanId: string, rolloutWaveId: string, force?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: undefined, context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling deleteRolloutWaveOperator.');
        }
        if (rolloutWaveId === null || rolloutWaveId === undefined) {
            throw new Error('Required parameter rolloutWaveId was null or undefined when calling deleteRolloutWaveOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>force, 'force');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/waves/${this.configuration.encodeParam({name: "rolloutWaveId", value: rolloutWaveId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<any>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get all supported targets that can be added in the rollout.
     * Get all supported targets that can be added in the rollout.
     * @param rolloutPlanId Rollout Plan ID
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param sortBy Sort the rollout waves addable targets by this column
     * @param sortByOrder Sort the properties by this order
     * @param orgId organization identifier in optional filter
     * @param orgName ORG name
     * @param orgType Org Type
     * @param deploymentName Deployment name
     * @param regionId Region ID of Cloud Provider
     * @param availabilityZone Availability zone
     * @param releaseVersion Release Version to look for.
     * @param vcdsServiceType VCDS Service Type
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAddableTargets(rolloutPlanId: string, pageNo?: number, pageSize?: number, sortBy?: 'name' | 'orgName' | 'vcdsServiceType' | 'provider' | 'version' | 'state', sortByOrder?: 'ASC' | 'DESC', orgId?: string, orgName?: string, orgType?: string, deploymentName?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', availabilityZone?: string, releaseVersion?: string, vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RolloutAddableTargetPaginatedResponse>;
    public getAddableTargets(rolloutPlanId: string, pageNo?: number, pageSize?: number, sortBy?: 'name' | 'orgName' | 'vcdsServiceType' | 'provider' | 'version' | 'state', sortByOrder?: 'ASC' | 'DESC', orgId?: string, orgName?: string, orgType?: string, deploymentName?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', availabilityZone?: string, releaseVersion?: string, vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutAddableTargetPaginatedResponse>>;
    public getAddableTargets(rolloutPlanId: string, pageNo?: number, pageSize?: number, sortBy?: 'name' | 'orgName' | 'vcdsServiceType' | 'provider' | 'version' | 'state', sortByOrder?: 'ASC' | 'DESC', orgId?: string, orgName?: string, orgType?: string, deploymentName?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', availabilityZone?: string, releaseVersion?: string, vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutAddableTargetPaginatedResponse>>;
    public getAddableTargets(rolloutPlanId: string, pageNo?: number, pageSize?: number, sortBy?: 'name' | 'orgName' | 'vcdsServiceType' | 'provider' | 'version' | 'state', sortByOrder?: 'ASC' | 'DESC', orgId?: string, orgName?: string, orgType?: string, deploymentName?: string, regionId?: 'ap-east-1' | 'ap-northeast-1' | 'ap-northeast-2' | 'ap-northeast-3' | 'ap-south-1' | 'ap-south-2' | 'ap-southeast-1' | 'ap-southeast-2' | 'ap-southeast-3' | 'ap-southeast-4' | 'af-south-1' | 'eu-central-1' | 'eu-central-2' | 'eu-north-1' | 'eu-south-1' | 'eu-west-1' | 'eu-west-2' | 'eu-west-3' | 'me-central-1' | 'me-south-1' | 'sa-east-1' | 'ca-central-1' | 'us-east-1' | 'us-east-2' | 'us-west-1' | 'us-west-2', availabilityZone?: string, releaseVersion?: string, vcdsServiceType?: 'VCDS' | 'VCDR' | 'VMCFS' | 'SRM' | 'VSR', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling getAddableTargets.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgId, 'org-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgName, 'org-name');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>orgType, 'org-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>deploymentName, 'deployment-name');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>regionId, 'region-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>availabilityZone, 'availability-zone');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>releaseVersion, 'release-version');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>vcdsServiceType, 'vcds-service-type');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/addable-targets`;
        return this.httpClient.request<RolloutAddableTargetPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get details of rollout waves created.
     * Get rollout waves
     * @param rolloutPlanId Rollout Plan ID
     * @param rolloutWaveName Rollout wave name.
     * @param rolloutWaveState Wave state
     * @param rolloutWaveScheduleStart Filter for wave scheduled start time
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param sortBy Sort the rollout wave by this column
     * @param sortByOrder Sort the properties by this order
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllRolloutWavesOperator(rolloutPlanId: string, rolloutWaveName?: string, rolloutWaveState?: RolloutWaveState, rolloutWaveScheduleStart?: Date, pageNo?: number, pageSize?: number, sortBy?: 'name' | 'internalName' | 'state' | 'windowStartTime' | 'windowEndTime' | 'createdBy' | 'createdTs' | 'updatedBy' | 'updatedTs', sortByOrder?: 'ASC' | 'DESC', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<RolloutWavePaginatedResponse>;
    public getAllRolloutWavesOperator(rolloutPlanId: string, rolloutWaveName?: string, rolloutWaveState?: RolloutWaveState, rolloutWaveScheduleStart?: Date, pageNo?: number, pageSize?: number, sortBy?: 'name' | 'internalName' | 'state' | 'windowStartTime' | 'windowEndTime' | 'createdBy' | 'createdTs' | 'updatedBy' | 'updatedTs', sortByOrder?: 'ASC' | 'DESC', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutWavePaginatedResponse>>;
    public getAllRolloutWavesOperator(rolloutPlanId: string, rolloutWaveName?: string, rolloutWaveState?: RolloutWaveState, rolloutWaveScheduleStart?: Date, pageNo?: number, pageSize?: number, sortBy?: 'name' | 'internalName' | 'state' | 'windowStartTime' | 'windowEndTime' | 'createdBy' | 'createdTs' | 'updatedBy' | 'updatedTs', sortByOrder?: 'ASC' | 'DESC', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutWavePaginatedResponse>>;
    public getAllRolloutWavesOperator(rolloutPlanId: string, rolloutWaveName?: string, rolloutWaveState?: RolloutWaveState, rolloutWaveScheduleStart?: Date, pageNo?: number, pageSize?: number, sortBy?: 'name' | 'internalName' | 'state' | 'windowStartTime' | 'windowEndTime' | 'createdBy' | 'createdTs' | 'updatedBy' | 'updatedTs', sortByOrder?: 'ASC' | 'DESC', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling getAllRolloutWavesOperator.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutWaveName, 'rollout-wave-name');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutWaveState, 'rollout-wave-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutWaveScheduleStart, 'rollout-wave-schedule-start');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/waves`;
        return this.httpClient.request<RolloutWavePaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get details of rollouts created.
     * Get rollouts
     * @param rolloutPlanId Query by Rollout Plan ID.
     * @param rolloutState Rollout state.
     * @param rolloutName Rollout plan name.
     * @param rolloutType Rollout type.
     * @param rolloutResourceType Rollout resource type.
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param sortBy Sort the rollout plan by this column
     * @param sortByOrder Sort the properties by this order
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getAllRolloutsOperator(rolloutPlanId?: string, rolloutState?: RolloutState, rolloutName?: string, rolloutType?: RolloutType, rolloutResourceType?: RolloutTargetType, pageNo?: number, pageSize?: number, sortBy?: 'name' | 'serviceType' | 'state' | 'rolloutVisibility' | 'createdBy' | 'createdTs' | 'updatedBy' | 'updatedTs', sortByOrder?: 'ASC' | 'DESC', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<RolloutPlanPaginatedResponse>;
    public getAllRolloutsOperator(rolloutPlanId?: string, rolloutState?: RolloutState, rolloutName?: string, rolloutType?: RolloutType, rolloutResourceType?: RolloutTargetType, pageNo?: number, pageSize?: number, sortBy?: 'name' | 'serviceType' | 'state' | 'rolloutVisibility' | 'createdBy' | 'createdTs' | 'updatedBy' | 'updatedTs', sortByOrder?: 'ASC' | 'DESC', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutPlanPaginatedResponse>>;
    public getAllRolloutsOperator(rolloutPlanId?: string, rolloutState?: RolloutState, rolloutName?: string, rolloutType?: RolloutType, rolloutResourceType?: RolloutTargetType, pageNo?: number, pageSize?: number, sortBy?: 'name' | 'serviceType' | 'state' | 'rolloutVisibility' | 'createdBy' | 'createdTs' | 'updatedBy' | 'updatedTs', sortByOrder?: 'ASC' | 'DESC', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutPlanPaginatedResponse>>;
    public getAllRolloutsOperator(rolloutPlanId?: string, rolloutState?: RolloutState, rolloutName?: string, rolloutType?: RolloutType, rolloutResourceType?: RolloutTargetType, pageNo?: number, pageSize?: number, sortBy?: 'name' | 'serviceType' | 'state' | 'rolloutVisibility' | 'createdBy' | 'createdTs' | 'updatedBy' | 'updatedTs', sortByOrder?: 'ASC' | 'DESC', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutPlanId, 'rollout-plan-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutState, 'rollout-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutName, 'rollout-name');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutType, 'rollout-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutResourceType, 'rollout-resource-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts`;
        return this.httpClient.request<RolloutPlanPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get details of rollout by id.
     * Get rollout by id
     * @param rolloutPlanId Rollout Plan ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRolloutOperator(rolloutPlanId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<RolloutPlanResponse>;
    public getRolloutOperator(rolloutPlanId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutPlanResponse>>;
    public getRolloutOperator(rolloutPlanId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutPlanResponse>>;
    public getRolloutOperator(rolloutPlanId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling getRolloutOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<RolloutPlanResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get Rollout types and supported options spec.
     * Get Rollout types and supported options spec.
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRolloutPlanOptionsSpecOperator(observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<RolloutPlanOptionsSpecResponse>;
    public getRolloutPlanOptionsSpecOperator(observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutPlanOptionsSpecResponse>>;
    public getRolloutPlanOptionsSpecOperator(observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutPlanOptionsSpecResponse>>;
    public getRolloutPlanOptionsSpecOperator(observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/options-spec`;
        return this.httpClient.request<RolloutPlanOptionsSpecResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a summary of Rollout Plan.
     * Get a summary of Rollout Plan.
     * @param rolloutPlanId Rollout Plan ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRolloutPlanSummary(rolloutPlanId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RolloutPlanSummary>;
    public getRolloutPlanSummary(rolloutPlanId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutPlanSummary>>;
    public getRolloutPlanSummary(rolloutPlanId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutPlanSummary>>;
    public getRolloutPlanSummary(rolloutPlanId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling getRolloutPlanSummary.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/summary`;
        return this.httpClient.request<RolloutPlanSummary>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get details of wave by id.
     * Get rollout wave by id
     * @param rolloutPlanId Rollout Plan ID
     * @param rolloutWaveId Rollout Wave ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRolloutWaveOperator(rolloutPlanId: string, rolloutWaveId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<RolloutWaveResponse>;
    public getRolloutWaveOperator(rolloutPlanId: string, rolloutWaveId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutWaveResponse>>;
    public getRolloutWaveOperator(rolloutPlanId: string, rolloutWaveId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutWaveResponse>>;
    public getRolloutWaveOperator(rolloutPlanId: string, rolloutWaveId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling getRolloutWaveOperator.');
        }
        if (rolloutWaveId === null || rolloutWaveId === undefined) {
            throw new Error('Required parameter rolloutWaveId was null or undefined when calling getRolloutWaveOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/waves/${this.configuration.encodeParam({name: "rolloutWaveId", value: rolloutWaveId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<RolloutWaveResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Get a summary of Rollout Wave.
     * Get a summary of Rollout Wave.
     * @param rolloutPlanId Rollout Plan ID
     * @param rolloutWaveId Rollout Wave ID
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public getRolloutWaveSummary(rolloutPlanId: string, rolloutWaveId: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RolloutWaveSummary>;
    public getRolloutWaveSummary(rolloutPlanId: string, rolloutWaveId: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutWaveSummary>>;
    public getRolloutWaveSummary(rolloutPlanId: string, rolloutWaveId: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutWaveSummary>>;
    public getRolloutWaveSummary(rolloutPlanId: string, rolloutWaveId: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling getRolloutWaveSummary.');
        }
        if (rolloutWaveId === null || rolloutWaveId === undefined) {
            throw new Error('Required parameter rolloutWaveId was null or undefined when calling getRolloutWaveSummary.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/waves/${this.configuration.encodeParam({name: "rolloutWaveId", value: rolloutWaveId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/summary`;
        return this.httpClient.request<RolloutWaveSummary>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch a rollout.
     * Patch a rollout.
     * @param rolloutPlanId Rollout Plan ID
     * @param rolloutPlanUpdateRequest Specification to update rollout
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchRolloutOperator(rolloutPlanId: string, rolloutPlanUpdateRequest: RolloutPlanUpdateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<RolloutPlanResponse>;
    public patchRolloutOperator(rolloutPlanId: string, rolloutPlanUpdateRequest: RolloutPlanUpdateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutPlanResponse>>;
    public patchRolloutOperator(rolloutPlanId: string, rolloutPlanUpdateRequest: RolloutPlanUpdateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutPlanResponse>>;
    public patchRolloutOperator(rolloutPlanId: string, rolloutPlanUpdateRequest: RolloutPlanUpdateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling patchRolloutOperator.');
        }
        if (rolloutPlanUpdateRequest === null || rolloutPlanUpdateRequest === undefined) {
            throw new Error('Required parameter rolloutPlanUpdateRequest was null or undefined when calling patchRolloutOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<RolloutPlanResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rolloutPlanUpdateRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Patch a rollout wave.
     * Patch a rollout wave.
     * @param rolloutPlanId Rollout Plan ID
     * @param rolloutWaveId Rollout Wave ID
     * @param rolloutWaveUpdateRequest Specification to update rollout
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public patchRolloutWaveOperator(rolloutPlanId: string, rolloutWaveId: string, rolloutWaveUpdateRequest: RolloutWaveUpdateRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<RolloutWaveResponse>;
    public patchRolloutWaveOperator(rolloutPlanId: string, rolloutWaveId: string, rolloutWaveUpdateRequest: RolloutWaveUpdateRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutWaveResponse>>;
    public patchRolloutWaveOperator(rolloutPlanId: string, rolloutWaveId: string, rolloutWaveUpdateRequest: RolloutWaveUpdateRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutWaveResponse>>;
    public patchRolloutWaveOperator(rolloutPlanId: string, rolloutWaveId: string, rolloutWaveUpdateRequest: RolloutWaveUpdateRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json' | 'text/plain', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling patchRolloutWaveOperator.');
        }
        if (rolloutWaveId === null || rolloutWaveId === undefined) {
            throw new Error('Required parameter rolloutWaveId was null or undefined when calling patchRolloutWaveOperator.');
        }
        if (rolloutWaveUpdateRequest === null || rolloutWaveUpdateRequest === undefined) {
            throw new Error('Required parameter rolloutWaveUpdateRequest was null or undefined when calling patchRolloutWaveOperator.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json',
            'text/plain'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/waves/${this.configuration.encodeParam({name: "rolloutWaveId", value: rolloutWaveId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<RolloutWaveResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rolloutWaveUpdateRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Query notification configs
     * Query notification configs
     * @param rolloutType Rollout type.
     * @param rolloutNotificationNameQuery Rollout notification name
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public queryNotifications(rolloutType?: RolloutType, rolloutNotificationNameQuery?: string, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<RolloutNotificationConfigResponse>>;
    public queryNotifications(rolloutType?: RolloutType, rolloutNotificationNameQuery?: string, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<RolloutNotificationConfigResponse>>>;
    public queryNotifications(rolloutType?: RolloutType, rolloutNotificationNameQuery?: string, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<RolloutNotificationConfigResponse>>>;
    public queryNotifications(rolloutType?: RolloutType, rolloutNotificationNameQuery?: string, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutType, 'rollout-type');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutNotificationNameQuery, 'rolloutNotificationNameQuery');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/notifications`;
        return this.httpClient.request<Array<RolloutNotificationConfigResponse>>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Query target details inside a wave.
     * Query target details inside a wave.
     * @param rolloutPlanId Rollout Plan ID
     * @param rolloutWaveId Rollout Wave ID
     * @param rolloutTargetId Query by Target ID.
     * @param rolloutTargetEntityId Query by Target Entity ID.
     * @param rolloutTargetState Query By Target State
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param sortBy Sort the rollout target by this column
     * @param sortByOrder Sort the properties by this order
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public queryTargetDetails(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetId?: string, rolloutTargetEntityId?: string, rolloutTargetState?: RolloutTargetState, pageNo?: number, pageSize?: number, sortBy?: 'state' | 'targetType' | 'createdBy' | 'createdTs' | 'updatedBy' | 'updatedTs', sortByOrder?: 'ASC' | 'DESC', observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RolloutTargetDetailedPaginatedResponse>;
    public queryTargetDetails(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetId?: string, rolloutTargetEntityId?: string, rolloutTargetState?: RolloutTargetState, pageNo?: number, pageSize?: number, sortBy?: 'state' | 'targetType' | 'createdBy' | 'createdTs' | 'updatedBy' | 'updatedTs', sortByOrder?: 'ASC' | 'DESC', observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutTargetDetailedPaginatedResponse>>;
    public queryTargetDetails(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetId?: string, rolloutTargetEntityId?: string, rolloutTargetState?: RolloutTargetState, pageNo?: number, pageSize?: number, sortBy?: 'state' | 'targetType' | 'createdBy' | 'createdTs' | 'updatedBy' | 'updatedTs', sortByOrder?: 'ASC' | 'DESC', observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutTargetDetailedPaginatedResponse>>;
    public queryTargetDetails(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetId?: string, rolloutTargetEntityId?: string, rolloutTargetState?: RolloutTargetState, pageNo?: number, pageSize?: number, sortBy?: 'state' | 'targetType' | 'createdBy' | 'createdTs' | 'updatedBy' | 'updatedTs', sortByOrder?: 'ASC' | 'DESC', observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling queryTargetDetails.');
        }
        if (rolloutWaveId === null || rolloutWaveId === undefined) {
            throw new Error('Required parameter rolloutWaveId was null or undefined when calling queryTargetDetails.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutTargetId, 'rollout-target-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutTargetEntityId, 'rollout-target-entity-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutTargetState, 'rollout-target-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortBy, 'sort-by');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>sortByOrder, 'sort-by-order');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/waves/${this.configuration.encodeParam({name: "rolloutWaveId", value: rolloutWaveId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/targets`;
        return this.httpClient.request<RolloutTargetDetailedPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Query targets across rollouts for operator debugging
     * Query targets across rollouts for operator debugging.
     * @param rolloutPlanId Query by Rollout Plan ID.
     * @param rolloutWaveId Query by Rollout Wave ID.
     * @param rolloutTargetId Query by Target ID.
     * @param rolloutTargetEntityId Query by Target Entity ID.
     * @param rolloutTargetState Query By Target State
     * @param pageNo Page Number (It starts from 0)
     * @param pageSize Page Size
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public queryTargetsOperator(rolloutPlanId?: string, rolloutWaveId?: string, rolloutTargetId?: string, rolloutTargetEntityId?: string, rolloutTargetState?: RolloutTargetState, pageNo?: number, pageSize?: number, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RolloutTargetPaginatedResponse>;
    public queryTargetsOperator(rolloutPlanId?: string, rolloutWaveId?: string, rolloutTargetId?: string, rolloutTargetEntityId?: string, rolloutTargetState?: RolloutTargetState, pageNo?: number, pageSize?: number, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutTargetPaginatedResponse>>;
    public queryTargetsOperator(rolloutPlanId?: string, rolloutWaveId?: string, rolloutTargetId?: string, rolloutTargetEntityId?: string, rolloutTargetState?: RolloutTargetState, pageNo?: number, pageSize?: number, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutTargetPaginatedResponse>>;
    public queryTargetsOperator(rolloutPlanId?: string, rolloutWaveId?: string, rolloutTargetId?: string, rolloutTargetEntityId?: string, rolloutTargetState?: RolloutTargetState, pageNo?: number, pageSize?: number, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutPlanId, 'rollout-plan-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutWaveId, 'rollout-wave-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutTargetId, 'rollout-target-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutTargetEntityId, 'rollout-target-entity-id');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>rolloutTargetState, 'rollout-target-state');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageNo, 'page-no');
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>pageSize, 'page-size');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/targets`;
        return this.httpClient.request<RolloutTargetPaginatedResponse>('get', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Remove targets as part of a wave.
     * Remove targets as part of a wave.
     * @param rolloutPlanId Rollout Plan ID
     * @param rolloutWaveId Rollout Wave ID
     * @param rolloutTargetRemoveRequest Rollout Target remove payload
     * @param force Invoke API, overriding any validations
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public removeTargetsFromWave(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetRemoveRequest: RolloutTargetRemoveRequest, force?: boolean, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<Array<RolloutTargetStatus>>;
    public removeTargetsFromWave(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetRemoveRequest: RolloutTargetRemoveRequest, force?: boolean, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<Array<RolloutTargetStatus>>>;
    public removeTargetsFromWave(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetRemoveRequest: RolloutTargetRemoveRequest, force?: boolean, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<Array<RolloutTargetStatus>>>;
    public removeTargetsFromWave(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetRemoveRequest: RolloutTargetRemoveRequest, force?: boolean, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling removeTargetsFromWave.');
        }
        if (rolloutWaveId === null || rolloutWaveId === undefined) {
            throw new Error('Required parameter rolloutWaveId was null or undefined when calling removeTargetsFromWave.');
        }
        if (rolloutTargetRemoveRequest === null || rolloutTargetRemoveRequest === undefined) {
            throw new Error('Required parameter rolloutTargetRemoveRequest was null or undefined when calling removeTargetsFromWave.');
        }

        let localVarQueryParameters = new HttpParams({encoder: this.encoder});
        localVarQueryParameters = this.addToHttpParams(localVarQueryParameters,
          <any>force, 'force');

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/waves/${this.configuration.encodeParam({name: "rolloutWaveId", value: rolloutWaveId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/targets`;
        return this.httpClient.request<Array<RolloutTargetStatus>>('delete', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rolloutTargetRemoveRequest,
                params: localVarQueryParameters,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update a rollout notification config
     * Update a rollout notification config
     * @param rolloutNotificationName Rollout notification name
     * @param rolloutNotificationConfigPatchRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateRolloutNotificationConfig(rolloutNotificationName: string, rolloutNotificationConfigPatchRequest?: RolloutNotificationConfigPatchRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RolloutNotificationConfigResponse>;
    public updateRolloutNotificationConfig(rolloutNotificationName: string, rolloutNotificationConfigPatchRequest?: RolloutNotificationConfigPatchRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutNotificationConfigResponse>>;
    public updateRolloutNotificationConfig(rolloutNotificationName: string, rolloutNotificationConfigPatchRequest?: RolloutNotificationConfigPatchRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutNotificationConfigResponse>>;
    public updateRolloutNotificationConfig(rolloutNotificationName: string, rolloutNotificationConfigPatchRequest?: RolloutNotificationConfigPatchRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutNotificationName === null || rolloutNotificationName === undefined) {
            throw new Error('Required parameter rolloutNotificationName was null or undefined when calling updateRolloutNotificationConfig.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/notifications/${this.configuration.encodeParam({name: "rolloutNotificationName", value: rolloutNotificationName, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: undefined})}`;
        return this.httpClient.request<RolloutNotificationConfigResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rolloutNotificationConfigPatchRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Update targets as part of a wave.
     * Update target details.
     * @param rolloutPlanId Rollout Plan ID
     * @param rolloutWaveId Rollout Wave ID
     * @param rolloutTargetId Rollout Target ID
     * @param rolloutTargetPatchRequest 
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public updateTarget(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetId: string, rolloutTargetPatchRequest?: RolloutTargetPatchRequest, observe?: 'body', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<RolloutTargetResponse>;
    public updateTarget(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetId: string, rolloutTargetPatchRequest?: RolloutTargetPatchRequest, observe?: 'response', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpResponse<RolloutTargetResponse>>;
    public updateTarget(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetId: string, rolloutTargetPatchRequest?: RolloutTargetPatchRequest, observe?: 'events', reportProgress?: boolean, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<HttpEvent<RolloutTargetResponse>>;
    public updateTarget(rolloutPlanId: string, rolloutWaveId: string, rolloutTargetId: string, rolloutTargetPatchRequest?: RolloutTargetPatchRequest, observe: any = 'body', reportProgress: boolean = false, options?: {httpHeaderAccept?: 'application/json', context?: HttpContext, transferCache?: boolean}): Observable<any> {
        if (rolloutPlanId === null || rolloutPlanId === undefined) {
            throw new Error('Required parameter rolloutPlanId was null or undefined when calling updateTarget.');
        }
        if (rolloutWaveId === null || rolloutWaveId === undefined) {
            throw new Error('Required parameter rolloutWaveId was null or undefined when calling updateTarget.');
        }
        if (rolloutTargetId === null || rolloutTargetId === undefined) {
            throw new Error('Required parameter rolloutTargetId was null or undefined when calling updateTarget.');
        }

        let localVarHeaders = this.defaultHeaders;

        // authentication (ApiKeyAuth) required
        localVarHeaders = this.configuration.addCredentialToHeaders('ApiKeyAuth', 'csp-auth-token', localVarHeaders);

        // authentication (AuthProvider) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthProvider', 'X-VLR-Idm-Type', localVarHeaders);

        // authentication (AuthorizationKey) required
        localVarHeaders = this.configuration.addCredentialToHeaders('AuthorizationKey', 'Authorization', localVarHeaders);

        const localVarHttpHeaderAcceptSelected: string | undefined = options?.httpHeaderAccept ?? this.configuration.selectHeaderAccept([
            'application/json'
        ]);
        if (localVarHttpHeaderAcceptSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Accept', localVarHttpHeaderAcceptSelected);
        }

        const localVarHttpContext: HttpContext = options?.context ?? new HttpContext();

        const localVarTransferCache: boolean = options?.transferCache ?? true;


        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected !== undefined) {
            localVarHeaders = localVarHeaders.set('Content-Type', httpContentTypeSelected);
        }

        let responseType_: 'text' | 'json' | 'blob' = 'json';
        if (localVarHttpHeaderAcceptSelected) {
            if (localVarHttpHeaderAcceptSelected.startsWith('text')) {
                responseType_ = 'text';
            } else if (this.configuration.isJsonMime(localVarHttpHeaderAcceptSelected)) {
                responseType_ = 'json';
            } else {
                responseType_ = 'blob';
            }
        }

        let localVarPath = `/vcds/operator/rollouts/${this.configuration.encodeParam({name: "rolloutPlanId", value: rolloutPlanId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/waves/${this.configuration.encodeParam({name: "rolloutWaveId", value: rolloutWaveId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}/targets/${this.configuration.encodeParam({name: "rolloutTargetId", value: rolloutTargetId, in: "path", style: "simple", explode: false, dataType: "string", dataFormat: "uuid"})}`;
        return this.httpClient.request<RolloutTargetResponse>('patch', `${this.configuration.basePath}${localVarPath}`,
            {
                context: localVarHttpContext,
                body: rolloutTargetPatchRequest,
                responseType: <any>responseType_,
                withCredentials: this.configuration.withCredentials,
                headers: localVarHeaders,
                observe: observe,
                transferCache: localVarTransferCache,
                reportProgress: reportProgress
            }
        );
    }

}
